import { Component } from "@angular/core";

@Component({
  selector: 'td[app-dt-body-td]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrls: ['dt-body-td.component.scss'],
})
export class DtBodyTdComponent {
}